import React, { useState } from 'react'
import MuiMenu from '@mui/material/Menu'
import MuiBox from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import MuiTypography from '@mui/material/Typography'
import LogoutIcon from '../common/Icons/Logout'
import ConfirmationPopUp from './ConfirmationPopUp'
import Avatar from '@mui/material/Avatar'
import { useSelector } from 'react-redux';
// import { useAuth } from 'react-oidc-context'

const LogoutCard = ({ open, onClose, anchorEl,handleStorageChange }) => {
  const [confirmationPopup, setConfirmationPopup] = useState(false)
  const { user } = useSelector((state) => state.auth);
  const togglePopup = () => {
    setConfirmationPopup(!confirmationPopup)
    console.log(confirmationPopup)
   if(confirmationPopup){
    onClose()
   }
  }

  const theme = useTheme()
  // const auth = useAuth()
  const userDetails = JSON.parse(localStorage.getItem('user_details'))
  const idName =  userDetails?.username ?? ""
  // const idName = jwt(token)?.data?.USERNAME
  const username = user?.username ?? (idName + ' ')?.split(' ')
  const initialsAvatar =
    username?.shift()?.charAt(0)?.toUpperCase() + username?.shift()?.charAt(0)?.toUpperCase()

  
  return (
    <MuiMenu
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiList-root': {
          padding: '0px',
        },
      }}
    >
      <MuiBox
        sx={{
          height: '116px',
          margin: '0px 14px',
          paddingTop: '24px',
          borderBottom: `1px solid ${theme.palette.primary[200]}`,
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar
          sx={{
            height: '48px',
            width: '48px',
            marginBottom: '8px',
          }}
        >
          {initialsAvatar}
        </Avatar>
        <MuiTypography variant="body1">{idName}</MuiTypography>
      </MuiBox>
      <MuiBox
        sx={{
          width: '240px',
          height: '64px',
          boxSizing: 'border-box',
          display: 'flex',
          alignItems: 'center',
          '& :hover': {
            backgroundColor: theme.palette.primary[50],
            cursor: 'pointer',
          },
        }}
      >
        <MuiBox
          sx={{
            width: '100%',
            display: 'flex',
            height: '32px',
            alignItems: 'center',
          }}
          onClick={togglePopup}
        >
          <LogoutIcon sx={{ marginLeft: '10px', marginRight: '18px' }} />
          <MuiTypography variant="body1">Logout</MuiTypography>
        </MuiBox>
      </MuiBox>
      {confirmationPopup && <ConfirmationPopUp open={confirmationPopup} setClose={togglePopup} handleStorageChange={handleStorageChange} />}
    </MuiMenu>
  )
}

export default LogoutCard
